namespace advisorop.components.servicer {

    class WorkflowCrudController {

        $router;
        lovs: Array<domains.ILOV> = [];

        dg: DevExpress.ui.dxDataGridOptions;
        wfdiagram: DevExpress.ui.dxDiagramOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        advisoryFirmId: number;

        updatingWorkflowLadda: boolean = false;
        workflows: domains.IWorkflowMaster[] = [];
        modelWorkflow: domains.IWorkflowMaster;
        selWorkflowId: number = 0;

        initialWorkflowNodes: domains.IWorkflowShape[];
        initialWorkflowEdges: domains.IWorkflowConnector[];

        workflowsLoaded = false;

        static $inject = ["generalService", "identityService", "servicerService", "advisoryFirmApi", "workflowApi"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private workflowApi: services.WorkflowApi) {

            var guidmap: { [id: string]: string; } = {};

            guidmap["100"] = new DevExpress.data.Guid().toString();
            guidmap["101"] = new DevExpress.data.Guid().toString();
            guidmap["102"] = new DevExpress.data.Guid().toString();
            guidmap["103"] = new DevExpress.data.Guid().toString();
            guidmap["105"] = new DevExpress.data.Guid().toString();
            guidmap["106"] = new DevExpress.data.Guid().toString();
            guidmap["107"] = new DevExpress.data.Guid().toString();
            guidmap["200"] = new DevExpress.data.Guid().toString();
            guidmap["201"] = new DevExpress.data.Guid().toString();
            guidmap["202"] = new DevExpress.data.Guid().toString();
            guidmap["203"] = new DevExpress.data.Guid().toString();
            guidmap["204"] = new DevExpress.data.Guid().toString();
            guidmap["206"] = new DevExpress.data.Guid().toString();
            guidmap["207"] = new DevExpress.data.Guid().toString();

            this.initialWorkflowNodes = [
                {
                    id: guidmap["100"],
                    type: "terminator",
                    text: "START",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["101"],
                    type: "aoprocess",
                    text: "Step 1",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["107"],
                    type: "aoprocess",
                    text: "Remedy Step",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["102"],
                    type: "aodecision",
                    text: "Decision?",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["103"],
                    type: "aoprocess",
                    text: "Step 2a",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["105"],
                    type: "aoprocess",
                    text: "Step 3",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
                {
                    id: guidmap["106"],
                    type: "terminator",
                    text: "END",
                    claimAllowedAllTimes: false,
                    autoComplete: false,
                    aoId: 0
                },
            ];

            this.initialWorkflowEdges = [
                {
                    id: guidmap["200"],
                    from: guidmap["100"],
                    to: guidmap["101"],
                    aoId: 0
                },
                {
                    id: guidmap["201"],
                    from: guidmap["101"],
                    to: guidmap["102"],
                    aoId: 0
                },
                {
                    id: guidmap["202"],
                    from: guidmap["102"],
                    to: guidmap["103"],
                    text: "Yes",
                    positivityIndicator: 1,
                    aoId: 0
                },
                {
                    id: guidmap["203"],
                    from: guidmap["102"],
                    to: guidmap["107"],
                    text: "No",
                    positivityIndicator: 2,
                    aoId: 0
                },
                {
                    id: guidmap["204"],
                    from: guidmap["103"],
                    to: guidmap["105"],
                    aoId: 0
                },
                {
                    id: guidmap["206"],
                    from: guidmap["107"],
                    to: guidmap["102"],
                    aoId: 0
                },
                {
                    id: guidmap["207"],
                    from: guidmap["105"],
                    to: guidmap["106"],
                    aoId: 0
                },
            ];

            this.initModelWorkflow();

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Workflows"
                },
                bindingOptions: {
                    dataSource: "vm.workflows",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no workflows",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "id", visible: false, sortIndex: 0, sortOrder: "asc" },
                    { dataField: "name", caption: "Workflow Name", cellTemplate: "colWorkflowName" },
                    { dataField: "description", caption: "Description" },
                    { dataField: "xx", caption: "Actions", cellTemplate: "btnActions", width: "200" }
                ],
            };
        }

        initModelWorkflow(): void {
            this.modelWorkflow = <domains.IWorkflowMaster>({
                id: 0,
                advisoryFirmId: 0,
                name: "New Workflow Template",
                description: "",
                diagram: {
                    shapes: angular.copy(this.initialWorkflowNodes),
                    connectors: angular.copy(this.initialWorkflowEdges)
                }
            });
        }

        firmChanged(): void {
            //console.log("SELECTED FIRM IS:", this.selFirm);
            this.advisoryFirmId = this.selFirm.id;
            this.loadWorkflows();
        }

        newWorkflow(): void {
            this.initModelWorkflow();
            //console.log("NEW WORKFLOW, CURRENT WORKFLOW IS:", this.modelWorkflow);
            // add this to the workflow list... so that the ne-repeat will pick it up??
        };

        editWorkflow(workflowId: number): void {
            this.selWorkflowId = workflowId;
        }

        loadWorkflows(selectedWorkflowId?: number): void {
            this.workflowsLoaded = false;
            this.workflows = [];
            //console.log("ADV FIRM ID IS", this.advisoryFirmId);
            this.workflowApi.getWorkflows(this.advisoryFirmId)
                .then((response) => {
                    if (response.data) {
                        this.workflows = response.data;
                        if (typeof(selectedWorkflowId) !== 'undefined') {
                            this.selWorkflowId = selectedWorkflowId;
                        }
                    }
                    this.workflows.push(angular.copy(this.modelWorkflow));
                    this.dg.dataSource = this.workflows;

                    //console.log("WORKFLOWS", this.workflows);

                    // Connector labels may be in json format.
                    // If they are, convert to json string. This allows for labels to appear in multiple places on a connector
                    this.workflows.forEach(wf => {
                        //if (wf.diagram && wf.diagram.shapes) {
                        //    wf.diagram.shapes.forEach(sh => {
                        //        if (sh.text && sh.text.charAt(0) == '{') {
                        //            console.log("PARSING JSON", angular.copy(sh.text));
                        //            try {
                        //                const tmp = JSON.parse(sh.text);
                        //                sh.text = tmp;
                        //            } catch (e) {
                        //            }
                        //        }
                        //    });
                        //}
                        if (wf.diagram && wf.diagram.connectors) {
                            wf.diagram.connectors.forEach(co => {
                                if (co.text && co.text.charAt(0) == '{') {
                                    //console.log("PARSING JSON", angular.copy(co.text));
                                    try {
                                        const tmp = JSON.parse(co.text);
                                        co.text = tmp;
                                    } catch (e) {
                                    }
                                }
                            });
                        }
                    });

                    this.workflowsLoaded = true;
                    //console.log("Workflows loaded:", this.workflows);
                    //console.log("Model Workflow:", this.modelWorkflow);
                    // append the boilerplate 'new workflow' to the list of existing workflows
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflows for this advisory firm!");
                });
        };

        logout(): void {
            this.identityService.logout();
        }

        loadLovs(): void {
            return;
            //this.generalService.getLOVs()
            //    .then((data) => {
            //        this.lovs = data;
            //    }, (reason) => {
            //        toastr.error("Error " + reason);
            //    });
        };

        loadAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        };

        onSaveWorkflow = (id) => {
            // Add a new workflow template to the grid
            //this.workflows.push(angular.copy(this.modelWorkflow));

            //console.log("IN THE CALLBACK...");
            this.loadWorkflows(id as number);
        }

        $onInit(): void {
            //this.loadLovs();
            this.loadAdvisoryFirms();
        }

        $routerOnActivate(next, previous) {
            //if (next.params.id) {
            //    this.loadWorkflow(<number>next.params.id);
            //}
        }
    }

    class WorkflowCrud implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = WorkflowCrudController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/workflow-crud.html';
        }
    }
    angular.module(Constants.APP).component("workflowCrud", new WorkflowCrud());
}